import { CHANGELOG, SYSTEM_VERSION } from "./changelog";

const STORAGE_PREFIX = "atualizacoes_vistas";

const perfilPorTipo = {
  2: "MUNICIPIO",
  3: "DRS",
  5: "ADMIN",
  6: "USUARIO",
};

export const resolvePerfilChangelog = ({ perfilAtivo, acessoAtivo }) => {
  if (acessoAtivo?.tipoPerfil) return String(acessoAtivo.tipoPerfil).toUpperCase();
  const tipoNumerico = Number(perfilAtivo?.tipo);
  return perfilPorTipo[tipoNumerico] || "ADMIN";
};

export const resolveUserId = (perfilAtivo) => {
  return perfilAtivo?.id || localStorage.getItem("userLogadoId") || null;
};

export const getVisibleUpdates = ({ perfilAtivo, acessoAtivo }) => {
  const perfil = resolvePerfilChangelog({ perfilAtivo, acessoAtivo });
  return CHANGELOG.filter((item) => item.perfis.includes(perfil));
};

const getStorageKey = (userId) => `${STORAGE_PREFIX}:${userId}`;

export const getSeenVersion = (userId) => {
  if (!userId) return null;

  const key = getStorageKey(userId);
  const value = localStorage.getItem(key);

  if (value) return value;

  // Compatibilidade com implementação antiga.
  const legacy = localStorage.getItem("ultimaAtualizacaoVista");
  if (legacy) {
    localStorage.setItem(key, legacy);
    return legacy;
  }

  return null;
};

export const markUpdatesAsSeen = (userId, version = SYSTEM_VERSION) => {
  if (!userId) return;
  localStorage.setItem(getStorageKey(userId), version);
  window.dispatchEvent(new Event("updates:seen-changed"));
};

export const hasUnreadUpdates = ({ perfilAtivo, acessoAtivo }) => {
  const userId = resolveUserId(perfilAtivo);
  if (!userId || !acessoAtivo?.idOrganograma) return false;

  const visibleUpdates = getVisibleUpdates({ perfilAtivo, acessoAtivo });
  if (visibleUpdates.length === 0) return false;

  const seenVersion = getSeenVersion(userId);
  return seenVersion !== SYSTEM_VERSION;
};
